/* eslint-disable max-len */

/**
 *  Init Desktop aka Glider
 */
const initDesktopHorizontalGlider = () => {
  const section = document.querySelector('[data-samples-section]');
  const containerWrapper = document.querySelector('[data-samples-container-wrapper]');
  const container = document.querySelector('[data-samples-container]');
  const samplesItems = document.querySelector('[data-samples-items]');
  const samplesItem = document.querySelectorAll('[data-samples-item]');

  let containerHeight = 0;
  let samplesItemsWidth = 0;
  let wrapperWidth = 0;
  let wrapperDiff = 0;
  let containerWrapperHeight = 0;
  let containerPaddTop = 0;


  const init = () => {
    const sectionCoords = section.getBoundingClientRect();
    const containerCoords = container.getBoundingClientRect();

    [].slice.call(samplesItem).forEach((sample) => {
      wrapperWidth += sample.offsetWidth;
    });

    containerHeight = container.offsetHeight;
    samplesItemsWidth = samplesItems.offsetWidth;
    wrapperDiff = wrapperWidth - samplesItemsWidth;
    containerPaddTop = containerCoords.top - sectionCoords.top;
    containerWrapperHeight = containerHeight + wrapperDiff + containerPaddTop;

    samplesItems.style.width = `${wrapperWidth}px`;
    containerWrapper.style.height = `${containerWrapperHeight}px`;
  };

  const calc = () => {
    const sectionCoords = section.getBoundingClientRect();
    const containerWrapperCoords = containerWrapper.getBoundingClientRect();

    const isStickyTop = (containerWrapperCoords.top <= containerPaddTop) && (sectionCoords.top <= 0) && (sectionCoords.top < containerPaddTop);
    const isStickyBottom = (containerHeight + containerPaddTop) > (containerWrapperHeight + containerWrapperCoords.top);

    const glide = sectionCoords.top;

    if (isStickyTop) {
      if (isStickyBottom) {
        container.style.position = 'absolute';
        container.style.top = 'auto';
        container.style.bottom = '0';

        samplesItems.style.left = `${-wrapperDiff}px`;
      } else {
        container.style.position = 'fixed';
        container.style.top = `${containerPaddTop}px`;
        container.style.bottom = 'auto';

        samplesItems.style.left = `${glide}px`;
      }
    } else {
      container.style.position = 'relative';
      container.style.top = 'auto';
      container.style.bottom = 'auto';

      samplesItems.style.left = '0';
    }
  };

  init();
  calc();
  window.addEventListener('scroll', calc, false);
  window.addEventListener('resize', calc, false);
};

export default initDesktopHorizontalGlider;
